export default __webpack_public_path__ + "static/media/controller.183fef16.png";